import "@/App.css";
import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Process from "@/pages/Process";
import Contact from "@/pages/Contact";

// Scroll to top on route change (unless navigating to an in-page anchor).
const ScrollToTop = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (!hash) window.scrollTo({ top: 0 });
    }, [pathname, hash]);
    return null;
};

function App() {
    return (
        <div
            className="App min-h-screen"
            style={{ background: "#f4f4f5" }}
        >
            <ScrollToTop />
            <Navbar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/process" element={<Process />} />
                <Route path="/contact" element={<Contact />} />
            </Routes>
            <Footer />
            <Toaster position="bottom-center" />
        </div>
    );
}

export default App;
